import type {
  EdgeId,
  IntentRule,
  PathLookupDeviceDecisionsMap,
  PathLookupGraphPreset,
  SnapshotId,
  StpInstance,
} from '@ipfabric/utils';
import { createContext, useContext } from 'react';
import type {
  PathInspectorPackets,
  PathLookupPathInspectorSelectedPackets,
} from './deviceViewTypes';

export interface DeviceViewContentContextProps {
  decisions?: PathLookupDeviceDecisionsMap | null;
  disableSiteLink?: boolean;
  hoveredPathInspectorEdge?: EdgeId | null;
  intentRule: IntentRule | null;
  isolateStpInstances?: boolean;
  /** Refresh the parent ApiTable (e.g. inventory devices) after explorer edits. */
  onReloadParentTable?: () => void;
  pathInspectorPackets?: PathInspectorPackets | null;
  pathLookupPathInspectorSelectedPackets?: PathLookupPathInspectorSelectedPackets;
  pathLookupPreset?: PathLookupGraphPreset;
  showLoader: boolean;
  snapshotId: SnapshotId | null;
  snapshotToCompareId?: SnapshotId | null;
  stpInstances?: StpInstance[];
}

const defaultValues = {
  intentRule: null,
  showLoader: false,
  snapshotId: null,
};

export const DeviceViewContentContext =
  createContext<DeviceViewContentContextProps>(defaultValues);

export function useDeviceViewContent(): DeviceViewContentContextProps {
  const contentContext = useContext(DeviceViewContentContext);
  return contentContext;
}
